import Dispatcher from '../dispatcher';
import { ImageLightBoxActions } from '../constants/image_light_box/image_light_box_actions';

function showAction(payload) {
    Dispatcher.handleImageLightboxAction({
        type: ImageLightBoxActions.SHOW,
        payload,
    });
}

function hideAction() {
    Dispatcher.handleImageLightboxAction({
        type: ImageLightBoxActions.HIDE
    });
}

function expandAction() {
    Dispatcher.handleImageLightboxAction({
        type: ImageLightBoxActions.EXPAND
    });
}

export {
    showAction,
    hideAction,
    expandAction,
};
